import { useTranslation } from "react-i18next";
import PageLoader from "../../components/common/PageLoader";
import LandingFooter from "../../components/landing/LandingFooter";
import SmallContact from "../../components/common/SmallContact";
import { LandingSeo } from "../../components/landing/LandingSeo";
import LandingHero from "../../components/landing/LandingHero";
import LandingFeatures from "../../components/landing/LandingFeatures";
import LandingProducts from "../../components/landing/LandingProducts";
import LandingQuality from "../../components/landing/LandingQuality";
import LandingProjects from "../../components/landing/LandingProjects";
import { getMainSiteUrl, LANDING_PAGE_SLUG } from "../../constants/appConfig";
import { useLandingPageData } from "../../hooks/useLandingPageData";
import { acfText } from "../../utils/landingAcf";
import { isRtlLanguage } from "../../utils/i18n";
import "./LandingPage.css";

function LandingPage() {
  const { t, i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);
  const fontClass = isRtl ? "arFont" : "enFont";
  const { page, acf, resolveImage, resolveMedia, loading, error } = useLandingPageData(
    LANDING_PAGE_SLUG,
  );
  const heroImageUrl = resolveImage(acf.hero_image);

  if (loading) {
    return (
      <div className={`landing-page-shell ${fontClass}`}>
        <PageLoader />
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className={`landing-page-shell ${fontClass}`}>
        <section className="landing-page__state">
          <h1>{t("Content unavailable")}</h1>
          <p>{t("landing.loadError", { slug: LANDING_PAGE_SLUG })}</p>
          <a href={getMainSiteUrl()} className="hero-btn hero-btn--primary inline-flex max-w-xs">
            <span className="hero-btn__label">{t("Visit Main Site")}</span>
          </a>
        </section>
        <LandingFooter />
        <SmallContact />
      </div>
    );
  }

  return (
    <div className={`landing-page-shell ${fontClass}`} dir={isRtl ? "rtl" : "ltr"}>
      <LandingSeo page={page} acf={acf} heroImageUrl={heroImageUrl} />
      <main id="main-content">
        <LandingHero acf={acf} heroImageUrl={heroImageUrl} />
        <LandingFeatures acf={acf} />
        <LandingProducts acf={acf} resolveMedia={resolveMedia} />
        <LandingQuality acf={acf} />
        <LandingProjects acf={acf} resolveImage={resolveImage} />
      </main>
      <LandingFooter />
      <SmallContact />
    </div>
  );
}

export default LandingPage;
